import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const Paragraph = styled.p`
  line-height: 18px;
  margin: ${({ noGutter }) => (noGutter ? '0' : '10px 0')};

  ${media.md`
    margin: ${({ noGutter }) => (noGutter ? '0' : '10px 0 40px 0')};
  `}
`;

export default Paragraph;
